<template>
  <div id="zipform" ref="zipform" :class="formStyle">
    <form @submit.prevent="onFormSubmit">
      <div class="field">
        <label class="form-title">{{ formTitle }}</label>
        <input ref="zipInput" v-model="zipCode" class="input-field" type="text" :placeholder="zipCodeHint" />
        <span v-if="toShowZipCodeError" class="zip-code-error error">{{ zipCodeError }}</span>
      </div>
      <input class="submit-button button" type="submit" value="Update" />
    </form>
  </div>
</template>

<script>
import { http, ZipUtils } from '@article/pixel';
import { mapState, mapActions } from 'vuex';
import LocationService from '@/services/LocationService';

const ZIP_ERROR_MESSAGE = "We couldn't find a location for this code. Is it correct?";
const GET_ZIP_SUCCESS = 'getZipSuccess';
const GET_ZIP_ERROR = 'getZipError';

export default {
  name: 'ZipForm',
  props: {
    value: String,
    formStyle: String,
  },
  data() {
    return {
      zipCode: '',
      zipCodeError: ZIP_ERROR_MESSAGE,
      toShowZipCodeError: false,
      formTitle: '',
      zipCodeHint: '',
    };
  },
  beforeMount() {
    if (LocationService.isCanada()) {
      this.formTitle = 'Enter postal code';
      this.zipCodeHint = 'e.g. V6A1C7';
    } else {
      this.formTitle = 'Enter ZIP code';
      this.zipCodeHint = 'e.g. 90221';
    }
  },
  methods: {
    ...mapActions('common', ['updateLocation']),

    async onFormSubmit(event) {
      if (!this.zipCode) {
        return;
      }

      this.toShowZipCodeError = false;

      this.zipCode = this.zipCode.trim();
      if (ZipUtils.isValidZip(this.zipCode)) {
        const { zipLocation } = await this.updateLocation({ zip: this.zipCode });
        try {
          this.toShowZipCodeError = !zipLocation?.zipcode;

          if (zipLocation?.zipcode) {
            LocationService.setIsLocationManual(true);
            this.$emit(GET_ZIP_SUCCESS, zipLocation.zipcode);
          } else {
            this.$emit(GET_ZIP_ERROR);
          }
        } catch (error) {
          this.toShowZipCodeError = true;
          this.$emit(GET_ZIP_ERROR, data);
        }
      } else {
        this.toShowZipCodeError = true;
        this.$emit(GET_ZIP_ERROR);
      }
    },
  },
  computed: {
    ...mapState('product', ['zipFormVisible']),
  },
  watch: {
    zipFormVisible: {
      handler(value) {
        if (value) {
          const { zipInput } = this.$refs;
          zipInput && zipInput.focus();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@article/pixel/dist/style/variables';

#zipform {
  padding: 16px;
  background: white;

  &.inline {
    form {
      text-align: center;
      align-items: center;
    }
  }

  @media (max-width: $tablet-breakpoint - 1) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  form {
    display: flex;
    flex-direction: column;
    max-width: 180px;

    .zip-code-error {
      margin-top: 8px;
      color: var(--coral);
    }
  }
}
</style>
